export default "__VITE_ASSET__35c724e6__"